import OverdueIcon from "@mui/icons-material/Block";
import PaidIcon from "@mui/icons-material/CheckRounded";
import DeletedIcon from "@mui/icons-material/CloseRounded";
import EmailedIcon from "@mui/icons-material/MoreHorizRounded";
import InactiveIcon from "@mui/icons-material/PriorityHighRounded";
import {
  DELETED_INVOICE_STATUS,
  EMAILED_INVOICE_STATUS,
  OVERDUE_INVOICE_STATUS,
  PAID_INVOICE_STATUS,
} from "../../../constants";

export const getInvoiceStatusIcon = (status) => {
  switch (status) {
    case OVERDUE_INVOICE_STATUS:
      return OverdueIcon;
    case EMAILED_INVOICE_STATUS:
      return EmailedIcon;
    case PAID_INVOICE_STATUS:
      return PaidIcon;
    case DELETED_INVOICE_STATUS:
      return DeletedIcon;
    default:
      return InactiveIcon;
  }
};

export const getInvoiceStatusColor = (status) => {
  switch (status) {
    case EMAILED_INVOICE_STATUS:
      return "warning";
    case PAID_INVOICE_STATUS:
      return "primary";
    case DELETED_INVOICE_STATUS:
    case OVERDUE_INVOICE_STATUS:
      return "error";
    default:
      return "info";
  }
};

export const checkActiveInvoiceStatus = (status) => {
  return [EMAILED_INVOICE_STATUS, PAID_INVOICE_STATUS].includes(status);
};
